import React, { useEffect } from 'react'
import { NavLink, BrowserRouter } from 'react-router-dom'
import Tooltip from '../Tooltip/Tooltip'
import Button from '../Button/Button'
import './TopNavBar.css'
import { Icon } from '../Icon2/Icon';
import { isMac } from './utils';

export interface NavBarProductProps {
    url: string;
    logoTitle?: string;
    logoIcon: string;
    logoVersion: string;
    trialExpired: boolean;
    onNavigate: (url: string) => void;
    pathName?: string;
    productID?: string;
    separator?: boolean;
    isSelectedState?: boolean;
}

const TopNavBarProduct: React.FC<NavBarProductProps> = ({
    url,
    logoTitle,
    logoIcon,
    logoVersion,
    trialExpired,
    onNavigate,
    pathName,
    productID,
    separator,
    isSelectedState
}): JSX.Element => {

    const handleRedirect = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.currentTarget.blur();
        if (!url) {
            return;
        }
        if ((isMac() && e.metaKey) || (!isMac() && e.ctrlKey)) {
            window.open(`/#!${url}`, '_blank');
        } else {
            onNavigate(url);
        }
    };

    useEffect(() => {
        const el = document.getElementById(
            "TopNavbar__content__product__button__with_svg"
        );
        el?.focus();
    }, []);

    const isSelected =
        isSelectedState || (productID !== undefined &&
            pathName !== undefined &&
            productID === pathName)
            ? '__isSelected'
            : '';

    if (logoVersion === 'v2') {
        return (
            <BrowserRouter>
                <Tooltip position="right" content={logoTitle}>
                    <div className='TopNavbar__content__product flex-v-center'>
                        <NavLink to={`/#!${url}`} onClick={(e) => e.preventDefault()} tabIndex={-1}>
                            <Button
                                version='v2'
                                className={`TopNavbar__content__product__button${isSelected} flex-v-center`}
                                onClick={handleRedirect}
                                aria-label={logoTitle.toLowerCase()}
                                testId={`cs-${logoTitle.toLowerCase()}-button`}
                                role='link'
                                buttonType='tertiary'
                                icon={`v2-${logoIcon}`}
                                iconProps={{
                                    version: logoVersion,
                                    size: 'original',
                                }}
                                size='small'
                                style={{padding: '0.5rem'}}
                            >
                                {logoTitle}
                            </Button>
                        </NavLink>
                        {separator ? <div className='TopNavbar__content__product--separator'></div> : null}
                    </div>
                </Tooltip>
            </BrowserRouter>
        )
    }

    return (
        <BrowserRouter>
            <div className='TopNavbar__content__product flex-v-center'>
                <NavLink to={`/#!${url}`} onClick={(e) => e.preventDefault()} tabIndex={-1}>
                    <Button
                        version='v2'
                        className={`TopNavbar__content__product__button__with_svg${isSelected} flex-v-center`}
                        id="TopNavbar__content__product__button__with_svg"
                        onClick={handleRedirect}
                        aria-label={logoTitle.toLowerCase()}
                        testId={`cs-${logoTitle.toLowerCase()}-button`}
                        role='link'
                        buttonType='tertiary'
                    >
                        <div className={`TopNavbar__content__product__button-svg-logo${isSelected} flex-v-center`} data-test-id="TopNavbar__content__product__button-svg-logo">
                            <Icon icon={logoIcon} version={'v3'} />
                        </div>
                    </Button>
                </NavLink>
                {separator ? <div className='TopNavbar__content__product--separator'></div> : null}
            </div>
        </BrowserRouter>
    )
}

export default TopNavBarProduct;
